exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-templates-art-jsx": () => import("./../../../src/templates/art.jsx" /* webpackChunkName: "component---src-templates-art-jsx" */),
  "component---src-templates-flexible-jsx": () => import("./../../../src/templates/flexible.jsx" /* webpackChunkName: "component---src-templates-flexible-jsx" */)
}

